import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AuthContainer } from "../../container/AuthLayout.styled";
import {
  AuthButton,
  AuthForm,
  AuthHeader,
  AuthInput,
  FormError,
  FormWrapper,
} from "../Auth.styled";
import ReactLoading from "react-loading";
import { useDispatch, useSelector } from "react-redux";
import { changePassword, logoutUser } from "../../feature/auth/AuthActions";
import { clearMessage } from "../../feature/message/messageSlice";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import SuccessPage from "../SuccessPage/SuccessPage";

const ChangePassword = () => {
  const { loading } = useSelector((state) => state.auth);
  const { inputError } = useSelector((state) => state.inputError);
  const [passwordChanged, setPasswordChanged] = useState(false);

  const dispatch = useDispatch();

  const initialValues = {
    old_password: "",
    new_password1: "",
    new_password2: "",
  };

  const onSubmit = (values) => {
    dispatch(changePassword(values))
      .unwrap()
      .then((res) => {
        setPasswordChanged(true);
        dispatch(logoutUser({}));
      })
      .catch((error) => console.log(error));
  };

  const validationSchema = Yup.object({
    old_password: Yup.string().required("Old password is required"),
    new_password1: Yup.string().required("Password is required"),
    new_password2: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("new_password1"), null], "Password Must Match"),
  });

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  useEffect(() => {
    dispatch(clearMessage());
    dispatch(clearInputError());
  }, [dispatch]);

  return (
    <>
      {passwordChanged ? (
        <SuccessPage
          message="Password Changed Successfully"
          links={[{ link: "/login", name: "Login" }]}
        />
      ) : (
        <AuthContainer>
          <AuthHeader>Change Password</AuthHeader>
          <svg
            width="431"
            height="109"
            viewBox="0 0 431 109"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "100%", marginBlock: "-100px 40px" }}
          >
            <path
              d="M1 40L61.8511 106L84.8875 11.5L168.34 64.5L220.933 40L243.97 106L295.258 2L375.669 91L430 75.5"
              stroke="#7B36EE"
              stroke-width="2"
            />
          </svg>
          <AuthForm onSubmit={formik.handleSubmit}>
            <FormError>
              {inputError !== undefined
                ? inputError.new_password2
                  ? inputError.new_password2
                  : null
                : null}
              {inputError !== undefined
                ? inputError.old_password
                  ? inputError.old_password
                  : null
                : null}
            </FormError>
            <FormWrapper>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginInlineEnd: "-20px" }}
              >
                <path
                  d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.5"
                  d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
                  fill="white"
                />
              </svg>
              <AuthInput
                type="password"
                name="old_password"
                placeholder="old password"
                onChange={formik.handleChange}
                value={formik.values.old_password}
              />
            </FormWrapper>
              <>
                {formik.errors.old_password ? (
                  <FormError>{formik.errors.old_password}</FormError>
                ) : null}
              </>
            <FormWrapper>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginInlineEnd: "-20px" }}
              >
                <path
                  d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.5"
                  d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
                  fill="white"
                />
              </svg>
              <AuthInput
                type="password"
                name="new_password1"
                placeholder="new password"
                onChange={formik.handleChange}
                value={formik.values.new_password1}
              />
            </FormWrapper>
              <>
                {formik.errors.new_password1 ? (
                  <FormError>{formik.errors.new_password1}</FormError>
                ) : null}
              </>
            <FormWrapper>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginInlineEnd: "-20px" }}
              >
                <path
                  d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.5"
                  d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
                  fill="white"
                />
              </svg>
              <AuthInput
                type="password"
                name="new_password2"
                placeholder="confirm new password"
                onChange={formik.handleChange}
                value={formik.values.new_password2}
              />
            </FormWrapper>
              <>
                {formik.errors.new_password2 ? (
                  <FormError>{formik.errors.new_password2}</FormError>
                ) : null}
              </>
            <AuthButton type="submit" disabled={loading}>
              {loading ? <ReactLoading
              type={"spinningBubbles"}
              height={"20px"}
              width={"20px"}
            /> : "Change"}
            </AuthButton>
          </AuthForm>
        </AuthContainer>
      )}
    </>
  );
};

export default ChangePassword;
